import { Button, Grid } from "@mui/material";
import { useFormik } from "formik";
import CustomSelect from "../../../../../components/CustomSelect";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { getXtenantId, showToastOnApiCall } from "../../../../../utils/utils";
import { useQueryClient } from "@tanstack/react-query";
import CustomTextArea from "../../../../../components/CustomTextArea";
import { useUpdateReferralStatus } from "../../../../../queries/use-update-referral-status";
import { GetAllReferralReferralStatusEnum } from "../../../../../services";
import {
  REFERRAL_STATUS_OPTIONS,
  REFERRAL_STATUS_VALIDATION_SCHEMA,
  ReferralStatus,
  referralStatusInitialValues,
} from "../collaboration-referral-constant";

interface ChangeReferralStatusProps {
  open: boolean;
  onClose: () => void;
  disclosureHost?: DisclosureHost;
}

const ChangeReferralStatus = ({
  open,
  onClose,
  disclosureHost,
}: ChangeReferralStatusProps) => {
  const client = useQueryClient();
  const { mutateAsync: updateReferralStatus } = useUpdateReferralStatus();

  const showSnackbar = useSnackbar();
  const formik = useFormik<ReferralStatus>({
    initialValues: referralStatusInitialValues,
    validationSchema: REFERRAL_STATUS_VALIDATION_SCHEMA,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  async function handleSubmit(values?: any) {
    const payload = {
      updateReferral: {
        uuid: disclosureHost?.data?.uuid,
        referralStatus:
          values?.referralStatus as GetAllReferralReferralStatusEnum,
        description: values?.description,
        referralId: disclosureHost?.data, // this is the Referral UUID
      },
      xTENANTID: getXtenantId(),
    };
    // console.log("payload", payload);
    showToastAndResetForm(updateReferralStatus(payload as any));
  }

  async function showToastAndResetForm(apiCall: Promise<any>) {
    showToastOnApiCall({
      apiCall,
      showSnackbar,
      onSave: () => {
        client.invalidateQueries({
          queryKey: ["collaboration-referral-list"],
        });
        closeAndResetForm();
      },
    });
  }

  function closeAndResetForm() {
    formik.resetForm();
    disclosureHost?.close();
    onClose();
  }

  return (
    <SideSheetDrawer
      open={open}
      onClose={() => closeAndResetForm()}
      title="Change Status"
      w="600px"
      footerActions={
        <Button
          size="large"
          variant="contained"
          onClick={() => formik.handleSubmit()}
        >
          Send
        </Button>
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomSelect
            label="Status"
            required
            options={REFERRAL_STATUS_OPTIONS}
            value={formik.values?.referralStatus}
            onChange={(value) => {
              formik.setFieldValue("referralStatus", value ?? undefined);
            }}
            error={
              formik.touched.referralStatus && formik.errors.referralStatus
            }
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextArea
            // required
            label="Description"
            placeholder="Description"
            name="description"
            value={formik.values?.description}
            onChange={formik.handleChange}
            minRows={4}
            error={
              formik.touched.description && (formik.errors.description as any)
            }
          />
        </Grid>
      </Grid>
    </SideSheetDrawer>
  );
};

export default ChangeReferralStatus;
